/* Minimal, no-server-sync wishlist
   - Saves wishlist in localStorage (key: RX_WISHLIST)
   - Toggles buttons with [data-wishlist-button]
   - Emits CustomEvent('rx:wishlist:change', {detail:{ids, items}})
   - Pushes dataLayer events: rx_wishlist_add / rx_wishlist_remove
*/

(function(){
  var STORAGE_KEY = 'RX_WISHLIST';

  var STORE = {
    read: function(){
      try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
      catch(e){ return []; }
    },
    write: function(arr){
      localStorage.setItem(STORAGE_KEY, JSON.stringify(arr));
    }
  };

  function uniqueByVariant(items){
    var seen = {};
    return items.filter(function(it){
      var key = String(it.variantId || '');
      if(seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function normalize(dataset){
    return {
      productId: Number(dataset.productId || dataset.productid || 0),
      variantId: Number(dataset.variantId || dataset.variantid || 0),
      handle: dataset.productHandle || dataset.producthandle || '',
      title: dataset.productTitle || dataset.producttitle || '',
      image: dataset.productImage || dataset.productimage || ''
    };
  }

  function listHas(variantId){
    return STORE.read().some(function(i){ return Number(i.variantId) === Number(variantId); });
  }

  function broadcast(){
    var items = STORE.read();
    document.dispatchEvent(new CustomEvent('rx:wishlist:change', {
      detail: { ids: items.map(function(i){ return i.variantId; }), items: items }
    }));
  }

  function save(item){
    var items = STORE.read();
    items.push(item);
    items = uniqueByVariant(items);
    STORE.write(items);
    broadcast();
    return items;
  }

  function remove(variantId){
    var items = STORE.read().filter(function(i){ return Number(i.variantId) !== Number(variantId); });
    STORE.write(items);
    broadcast();
    return items;
  }

  function toggle(item){
    if(listHas(item.variantId)){
      return remove(item.variantId);
    } else {
      return save(item);
    }
  }

  function initButtons(root){
    (root || document).querySelectorAll('[data-wishlist-button]').forEach(function(btn){
      var item = normalize(btn.dataset);
      var on = listHas(item.variantId);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');

      btn.addEventListener('click', function(){
        var after = toggle(item);
        var stateOn = listHas(item.variantId);
        btn.setAttribute('aria-pressed', stateOn ? 'true' : 'false');
        var label = btn.querySelector('.rx-wishlist-label');
        if(label){ label.textContent = stateOn ? 'Wishlisted' : 'Add to wishlist'; }

        try {
          window.dataLayer && window.dataLayer.push({
            event: 'rx_wishlist_' + (stateOn ? 'add' : 'remove'),
            variant_id: item.variantId,
            product_id: item.productId
          });
        } catch(e){}
      });
    });
  }

  // Public API (optional)
  window.RXWishlist = {
    get: function(){ return STORE.read(); },
    clear: function(){ STORE.write([]); broadcast(); },
    remove: remove,
    save: save,
    has: listHas,
    refreshButtons: function(root){ initButtons(root || document); }
  };

  document.addEventListener('DOMContentLoaded', function(){
    initButtons(document);
    broadcast(); // let any wishlist page/component render current items
  });
})();
